import { ExecEdATFProps, UseExecEdATF, ExecEdATFVariants } from "./types";
import { useMonarchRule } from "../MonarchRulesProvider";

const CUSTOM_RULE_ID = "execEdAtfTest";

const useExecEdATF: UseExecEdATF = () => {
  const { isLoading, value } = useMonarchRule<{
    data: ExecEdATFProps;
  }>(CUSTOM_RULE_ID, {});

  if (isLoading) {
    return {
      isLoading,
      data: {
        conversionType: undefined,
        certificateFactoid: {
          showFactoidDesktop: false,
          showFactoidMobile: false,
          variantColor: "default",
          factoidText: "",
          factoidHeader: "",
          factoidIcon: "",
          factoidIconName: undefined,
          tooltip: null,
          position: 0,
        },
        heroBadges: {
          badges: [],
          position: "below-subheader",
        },
        promoBanner: undefined,
      },
    };
  }

  const variant = value?.data?.showTest === false ? "control" : "test";

  return {
    isLoading,
    variant,
    data: {
      showTest: value?.data?.showTest,
      conversionType: value?.data?.eventing?.conversionType,
      certificateFactoid: {
        ...value?.data?.certificateFactoid,
        factoidIconName: value?.data?.certificateFactoid?.factoidIconName,
      },
      heroBadges: {
        badges: value?.data?.heroBadges?.badges,
        position: value?.data?.heroBadges?.position ?? "below-subheader",
      },
      promoBanner: value?.data?.promoBanner,
    },
  };
};

export default useExecEdATF;
